import axios from "axios";
import { getCaid } from "@/data/regionInfo";

const instance = axios.create({
  headers: {
    Accept: "application/json",
    "Content-Type": "application/x-www-form-urlencoded"
  },
  transformRequest: [
    (data, headers) => {
      delete headers.common.Authorization;
      return data;
    }
  ]
});

instance.interceptors.request.use((config) => {
  const caid = getCaid() ? getCaid().caid : null;
  if(caid) config.params = {...config.params, caid};
  return config
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});

instance.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded";

export default instance;
